
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 85 78"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticClass:"i-mask0_2294_648",staticStyle:{"mask-type":"luminance"},attrs:{"width":"85","height":"78","x":"0","y":"0","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"fill":"#fff","d":"M25.416 9.623c7.408-12.83 25.929-12.831 33.337 0L81.56 49.13C88.97 61.96 79.71 78 64.893 78H19.276C4.459 78-4.801 61.961 2.607 49.13z"}})]),_c('g',{attrs:{"mask":"url(#mask0_2294_648)"}},[_c('path',{attrs:{"fill":"url(#paint0_linear_2294_648)","d":"M98.89 78.191H51.876l-9.73-16.851 23.509-40.717z"}}),_c('path',{attrs:{"fill":"url(#paint1_linear_2294_648)","d":"M-14.609 78.184 18.63 20.615v.002L8.903 37.463h19.453l23.51 40.719z"}}),_c('path',{attrs:{"fill":"url(#paint2_linear_2294_648)","d":"m42.148-20.102 23.51 40.72-9.727 16.849H8.91z"}})]),_c('defs',[_c('linearGradient',{staticClass:"i-paint0_linear_2294_648",attrs:{"x1":"92.083","x2":"45.772","y1":"74.906","y2":"47.077","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".09","stop-color":"#FFE921"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FEC700"}})]),_c('linearGradient',{staticClass:"i-paint1_linear_2294_648",attrs:{"x1":"51.559","x2":".971","y1":"83.098","y2":"52.495","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".15","stop-color":"#A9A8FF"}}),_c('stop',{attrs:{"offset":".33","stop-color":"#6D97FF"}}),_c('stop',{attrs:{"offset":".48","stop-color":"#3186FF"}})]),_c('linearGradient',{staticClass:"i-paint2_linear_2294_648",attrs:{"x1":"58.968","x2":"7.71","y1":"9.556","y2":"33.482","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".55","stop-color":"#0EBC5F"}}),_c('stop',{attrs:{"offset":".85","stop-color":"#78C9FF"}})])])])
          )
        }
      }
    